import axios from "axios";
import TaxLookup from "./data/TaxLookup";

import TaxRate from "./data/TaxRate";

const api = {
	debug: false,

	getTaxRates(year: string | null = null): Promise<Array<TaxRate>> {
		return new Promise((resolve, reject) => {
			if (!year) {
				const currentYear = new Date().getFullYear();
				const prevYear = currentYear - 1;

				year = prevYear.toString();
			}

			const endpoint = "https://datastore.geaugaconnected.com/wp-json/wp/v2/gca_tax_rate/?per_page=100&tax_rate_year_slug=" + year;

			if (this.debug) {
				console.log("getTaxRates():", endpoint);
			}

			let results = [] as Array<TaxRate>;

			axios.get(endpoint).then((resp) => {
				if (resp.status === 200 && resp.data) {
					let taxRates = resp.data;

					taxRates.forEach((rate: any) => {
						let metadata = rate.metadata;
						let taxRate = {} as TaxRate;

						for (const property in metadata) {
							(taxRate as TaxRate)[property] = metadata[property][0];
						}

						results.push(taxRate);
					});

					resolve(results);
				}
			});
		});
	},

	getTaxRate(districtCode: number): Promise<TaxRate> {
		return new Promise((resolve, reject) => {
			let endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/070fc0e3e31ffd99550e10ea0984fd46/o/tax-rate-lookup/" + districtCode;

			if (this.debug) {
				console.log("getTaxRate():", endpoint);
			}

			axios.get(endpoint).then((resp) => {
				if (resp.status === 200 && !!resp.data.data) {
					resolve(resp.data.data);
				}
			});
		});
	},

	getParcelTaxData(parcelId: string): Promise<TaxLookup> {
		return new Promise((resolve, reject) => {
			let endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/aa4a47c62c893997a0f7f2d369fa04eb/o/tax-data-lookup/" + parcelId;

			if (this.debug) {
				console.log("getParcelTaxData():", endpoint);
			}

			axios.get(endpoint).then((resp) => {
				if (resp.status === 200 && !!resp.data.data) {
					resolve(resp.data.data);
				}
			});
		});
	},

	getParcelTaxFacts(parcelId: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/350334ccf67fe6c973b06747f917dd9e/o/tax-facts-view-lookup/" + parcelId;

			if (this.debug) {
				console.log("getParcelTaxFacts():", endpoint);
			}

			axios.get(endpoint).then((resp) => {
				if (resp.status === 200 && !!resp.data) {
					resolve(resp.data.data);
				}
			});
		});
	},

	getSchoolDistrictCalc(parcelId: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/167cc25c46373ff3cb3da5e4e20e22df/o/school-district-calc-view-lookup/" + parcelId;

			if (this.debug) {
				console.log("getSchoolDistrictCalc():", endpoint);
			}

			axios.get(endpoint).then((resp) => {
				if (resp.status === 200 && !!resp.data.data) {
					resolve(resp.data.data);
				}
			});
		});
	},

	getHomesteadView(parcelId: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/3604af3f8bc28fd51b1e31477f3233c2/o/homestead-view-lookup/" + parcelId;

			if (this.debug) {
				console.log("getHomesteadView():", endpoint);
			}

			axios.get(endpoint).then((resp) => {
				if (resp.status === 200 && !!resp.data.data) {
					resolve(resp.data.data);
				}
			});
		});
	},

	getHomesteadSavings(districtCode: number): Promise<any> {
		return new Promise((resolve, reject) => {
			let endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/70d1f33582066d6fea1dc74b03e2fc1c/o/homestead-savings-lookup/" + districtCode;

			if (this.debug) {
				console.log("getHomesteadView():", endpoint);
			}

			axios.get(endpoint).then((resp) => {
				if (resp.status === 200 && !!resp.data.data) {
					resolve(resp.data.data);
				}
			});
		});
	},

	getOwnerOccupancyView(parcelId: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/a1d3ec75f1b642d32f5305697f914119/o/25calculator-view-lookup/" + parcelId;

			if (this.debug) {
				console.log("getOwnerOccupancyView():", endpoint);
			}

			axios.get(endpoint).then((resp) => {
				if (resp.status === 200 && !!resp.data.data) {
					resolve(resp.data.data);
				}
			});
		});
	},
};

export default api;
